import { Currency } from "@lookiero/sty-psp-locale";
import { Price } from "../../../domain/projections/Price";
import { CurrencyAndProductVariants } from "../../../domain/projections/Wishlist";

interface WishlistDTO {
  readonly currency: string;
  readonly wishlist: {
    readonly available: boolean;
    readonly brand: string;
    readonly color: string;
    readonly imageUrl: string;
    readonly price: number;
    readonly variantPrice: Price;
    readonly reference: string;
    readonly size: string;
    readonly title: string;
    readonly variantId: string;
    readonly lastUnits: boolean;
  }[];
}

const mapWishlistItemDTOtoCurrencyAndItems = (wishlistDTO: WishlistDTO): CurrencyAndProductVariants => ({
  currency: wishlistDTO.currency as Currency,
  productVariants: wishlistDTO.wishlist.map((productVariant) => ({
    available: productVariant.available,
    brand: productVariant.brand,
    color: productVariant.color,
    imageUrl: productVariant.imageUrl,
    price: productVariant.variantPrice,
    reference: productVariant.reference,
    size: productVariant.size,
    title: productVariant.title,
    variantId: productVariant.variantId,
    lastUnits: productVariant.lastUnits,
  })),
});

export type { WishlistDTO };
export { mapWishlistItemDTOtoCurrencyAndItems };
